// Import Swiper React components
import { styled } from "@mui/material";
import clsx from "clsx";
import { Swiper as LibSwiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const LibSwiperStyled = styled(LibSwiper)({
  paddingBottom: "2rem",
});
const SlideStyled = styled(SwiperSlide)({
  "&.follow-content": {
    width: "fit-content",
  },
});

const SwiperUnstyled = ({
  spaceBetween,
  slidesPerView,
  render,
  items = [],
  className,
  classNames = {},
}) => {
  return (
    <LibSwiperStyled
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      mousewheel
      pagination
      modules={[Mousewheel, Pagination]}
      className={className}
    >
      {items.map((item) => (
        <SlideStyled
          key={item.id}
          className={clsx(
            "slide",
            {
              "follow-content": slidesPerView === "auto",
            },
            classNames.slide
          )}
        >
          {render(item)}
        </SlideStyled>
      ))}
    </LibSwiperStyled>
  );
};

const Swiper = styled(SwiperUnstyled)({});
export default Swiper;
